import { getLang } from './index';
import { regReactPlugin, Options } from '../react-plugin/index';

export function needRTL() : boolean {
  // return true
  // return /^ar/.test(getLang());
  if (typeof window.rewriteLangRTL === 'function') return window.rewriteLangRTL()
  return /^ar/.test(getLang());
}

function addGlobalTransform(ele: HTMLElement) {
  ele?.style.setProperty('transform', 'scaleX(-1)');
}

function addStyle() {
  const rtlStyle = document.createElement('style');
  rtlStyle.innerHTML = '.ui-rtl{transform:scaleX(-1);direction:rtl}.ui-rtl-inline{display:inline-flex}';
  document.head.appendChild(rtlStyle);
}

// ? 复写会导致 vconsole 死循环
function fixTransformRTL(ele: HTMLElement, tagName?: string) {
  // 后续修改为添加 className 处理，提供 css，方便特殊节点单独处理，优化性能
  // if (!ele.classList.contains('ui-rtl')) {
  //   ele?.classList?.add('ui-rtl');
  //   if ((ele.nodeName === 'SPAN' || ele.nodeName === 'A')) {
  //     ele?.classList?.add('ui-rtl-inline');
  //   }
  // }
  if (!ele.getAttribute('data-rtl')) {
    // if (ele?.parentElement?.getAttribute?.('data-rtl') === 'true') return false;
    if (ele?.classList?.value?.indexOf('ui-icon') > -1) return false
    ele.setAttribute('data-rtl', 'true');

    ele?.classList?.add('ui-rtl');
    // ele?.style.setProperty('transform', 'scaleX(-1)');
    // ele?.style.setProperty('direction', 'rtl');

    if (tagName === 'INPUT' || tagName === 'TEXTAREA') {
      ele.setAttribute('dir', 'auto');
    }
    // 表头th 设置 text-align 属性
    // if (ele.nodeName === 'TH') {
    //   const originTextAlign = getComputedStyle(ele).getPropertyValue('text-align')
    //   if (originTextAlign === 'left' || originTextAlign === 'right') {
    //     ele?.style.setProperty('text-align', originTextAlign === 'left' ? 'right' : 'left');
    //   }
    // }

    // isConnected:false 无法判断 inline 还是 inline-block 强转处理，有风险
    if ((ele.nodeName === 'SPAN' || ele.nodeName === 'A')) {
      if (!ele?.classList.contains('ui-rtl-inline')) {
        ele?.classList?.add('ui-rtl-inline');
      }
      // ele?.style.setProperty('display', 'inline-flex');
      // ele?.style.setProperty('display', 'inline-block');
    }
  }
}

function checkTextEmpty(t: string) {
  return t?.replace(new RegExp(` |${decodeURI('%C2%A0')}`, 'g'), () => '')
}

function filberIsTextAndLTR(o: Options) {
  // console.info('appendChild、insertBefore', o);
  const tagName = o?.child?.tagName;
  const className = o?.child?.className?.baseVal || o?.child?.className;
  // 父节点已处理的不再做二次镜像处理
  if (
    o?.parentInstance?.getAttribute('data-rtl') === 'true' ||
    o?.container?.getAttribute('data-rtl') === 'true'
  ) {
    return o;
  }

  // 自定义渲染会有个空或者空格 &nbsp; 转义字符类？？ #text 这种父级不处理，处理子集
  if (
    o?.child?.nodeName === '#text' &&
    checkTextEmpty(o?.child?.nodeValue) &&
    o.parentInstance
  ) {
    fixTransformRTL(o.parentInstance);
  }

  // 输入、图标、图片、绘图等都要回归本体处理
  if (
    tagName === 'INPUT' ||
    tagName === 'TEXTAREA' ||
    tagName === 'IMG' ||
    /ui-echarts/i.test(className) ||
    (/ui-icon/i.test(className) &&
      !/ui-icon-wrapper/i.test(className) &&
      !/(left|right|up|down)-arrow/i.test(className)) ||
    /ui-checkbox-inner/.test(className)
  ) {
    fixTransformRTL(o.child, tagName);
  }

  // if (/ui-scroller/i.test(className)) {
  //   o.child?.style.setProperty('transform', 'scaleX(-1)');
  // }
  return o;
}

export function setRTL() {
  if (needRTL()) {
    // 全局翻转
    addGlobalTransform(document?.documentElement);
    // addStyle();
    regReactPlugin('setTextContent', o => {
      // console.info('setTextContent', o);
      fixTransformRTL(o.node);
      return o;
    });
    regReactPlugin('setInnerHTML', o => {
      // console.info('setInnerHTML', o);
      // fix code
      if (o?.node?.tagName === 'CODE') {
        addGlobalTransform(o.node);
        return o;
      }
      fixTransformRTL(o.node);
      return o;
    });
    regReactPlugin('appendChild', filberIsTextAndLTR);
    regReactPlugin('insertBefore', filberIsTextAndLTR);
  }
}

// vConsole 在 trigger 时候会死循环？
// js 根据窗口全局定位依赖屏幕的依然需要单独处理 Trigger、左对齐现在要右对齐
// 布局组件拖动大小，往左右拖动需要翻转逻辑       --  揭志胜 单独处理
// 弹框组件拖动位置
// Icon 需要翻转回去 ✅                      --  徐小平 单独处理
// Icon 方向箭头的不能翻转回去，需要处理         --  徐小平 单独处理
// title 属性不会被镜像，不用处理 ✅
// 代码展示和编辑器部分怎么处理？ 语言混用的时候   --  暂时不考虑
// text-align: left; 强行指定的，需单独处理    --  源码单独处理
// canvas 绘图的图标之类需要重新翻转过来
// :after 伪元素图标也需要翻转回来
// 时间选择器面板怎么处理？                     --  屈正巍 单独处理
// 不是 react 渲染的怎么处理？                 --  镜像filberIsTextAndLTR解析转换
// 富文本 iframe 需要单独处理 - 默认是支持的     --  陈佳敏 单独处理
// 多层嵌套节点都存在文本的可能会反复反转导致错误   --  测试验证
// 水印需要处理                               --  揭志胜 单独处理
// Intro